(()=>{
  if(window.__buhrSupplierStock) return;
  window.__buhrSupplierStock=true;
  const cache=new Map(), pending=new WeakMap(), queue=[];
  let running=0,timer;
  const labels=JSON.parse(document.querySelector('[data-buhr-stock-labels]')?.textContent||'{}');
  const number=new Intl.NumberFormat(document.documentElement.lang||'sv-SE');
  function format(root){root.querySelectorAll('[data-stock-quantity]').forEach(el=>{const qty=Number(el.dataset.stockQuantity);if(Number.isSafeInteger(qty)&&qty>=0)el.textContent=number.format(qty)+' '+el.textContent.trim().split(/\s+/).pop();});}
  function fetchStock(handle){
    if(cache.has(handle))return cache.get(handle);
    const promise=new Promise(resolve=>{queue.push({handle,resolve});drain();});
    cache.set(handle,promise);return promise;
  }
  function drain(){
    while(running<4&&queue.length){
      const {handle,resolve}=queue.shift();running++;
      const url=new URL('/products/'+encodeURIComponent(handle),location.origin);
      url.searchParams.set('view','buhr-stock');
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(12000)})
      .then(r=>{if(!r.ok)throw Error('stock');return r.json();})
      .then(resolve).catch(()=>{cache.delete(handle);resolve(null);})
      .finally(()=>{running--;drain();});
    }
  }
  function render(data){
    if(!data||data.schema!==1||!['quantity','contact'].includes(data.mode))return null;
    if(data.mode==='quantity'&&(!Number.isSafeInteger(data.quantity)||data.quantity<0||!['PCS','CTN'].includes(data.unit)))return null;
    const box=document.createElement('div');box.className='buhr-supplier-stock';box.dataset.buhrSupplierStock='';box.dataset.mode=data.mode;
    const add=(cl,text)=>{const el=document.createElement('span');el.className=cl;el.textContent=text;box.append(el);};
    if(data.mode==='contact')add('buhr-stock-line',labels.contact);
    else {add('buhr-stock-label',labels.supplier);add('buhr-stock-line',number.format(data.quantity)+' '+(data.unit==='CTN'?'CTN':labels.pieces));add('buhr-stock-date',labels.updated+' '+String(data.source_time_local).replace('T',' ').slice(0,16));}
    return box;
  }
  async function scan(){
    const cards=document.querySelectorAll('.product-card-wrapper,.card-wrapper');
    cards.forEach(async card=>{
      const link=card.querySelector('a[href*="/products/"]');if(!link)return;
      const handle=new URL(link.href,location.origin).pathname.match(/\/products\/([^/]+)/)?.[1];if(!handle)return;
      const old=card.querySelector('[data-buhr-supplier-stock]');
      const oldMode=old?.dataset.mode;
      const oldHasContent=Boolean(old?.querySelector('.buhr-stock-line')?.textContent.trim());
      const oldValid=Boolean(old&&['quantity','contact'].includes(oldMode)&&oldHasContent);
      if(oldValid&&!old.dataset.stockHandle){old.dataset.stockHandle=handle;return;}
      if((oldValid&&old.dataset.stockHandle===handle)||pending.get(card)===handle)return;
      old?.remove();pending.set(card,handle);
      const data=await fetchStock(handle);
      if(!card.isConnected||pending.get(card)!==handle)return;
      const current=card.querySelector('a[href*="/products/"]');
      if(!current||!new URL(current.href).pathname.endsWith('/'+handle)){pending.delete(card);return;}
      const box=render(data);if(!box)return;
      box.dataset.stockHandle=handle;
      const info=card.querySelector('.card > .card__content > .card__information')||card.querySelector('.card__information');
      if(!info)return;
      const action=info.querySelector('[data-buhr-studio-rapid-action],[data-buhr-studio-card-action]');
      if(action)info.insertBefore(box,action);else info.append(box);
    });
  }
  function alignStockRows(){
    const groups=[];
    document.querySelectorAll(':is(#product-grid,.rps-results,.template-search__results) .buhr-supplier-stock').forEach(box=>{
      box.style.removeProperty('--buhr-stock-offset');box.style.removeProperty('--buhr-stock-height');
    });
    document.querySelectorAll(':is(#product-grid,.rps-results,.template-search__results) .buhr-supplier-stock').forEach(box=>{
      const card=box.closest('.product-card-wrapper,.card-wrapper');
      if(!card||!box.getClientRects().length)return;
      const root=card.closest('#product-grid,.rps-results,.template-search__results');
      const rowTop=card.getBoundingClientRect().top;
      let group=groups.find(g=>g.root===root&&Math.abs(g.top-rowTop)<3);
      if(!group){group={root,top:rowTop,items:[]};groups.push(group);}
      const rect=box.getBoundingClientRect();group.items.push({box,top:rect.top,height:rect.height});
    });
    groups.forEach(group=>{
      const top=Math.max(...group.items.map(x=>x.top));
      const height=Math.max(...group.items.map(x=>x.height));
      group.items.forEach(x=>{x.box.style.setProperty('--buhr-stock-offset',Math.max(0,top-x.top)+'px');x.box.style.setProperty('--buhr-stock-height',height+'px');});
    });
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(()=>{scan();alignStockRows();},120);}
  format(document);scan();requestAnimationFrame(alignStockRows);
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('load',event=>{if(event.target.tagName==='IMG')schedule();},true);
  document.fonts?.ready.then(schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',()=>{format(document);schedule();});
})();
